import langContact from './langs/langContact';

const ContactsLangs = [langContact];

export default ContactsLangs;
